import BaseModule from './BaseModule'

class Role extends BaseModule {
  constructor() {
    super()
  }
  // 获取用户列表数据数据
  getMemberList(){
      return this.get(`/api/member`)
  }
  //用户列表模糊查询
  searchMemberList(addcim){
      return this.get(`/api/member?`+addcim)
  }
  //新增用户
  addMember(params){
      return this.post(`/api/member`,params)
  }
  //修改用户
  modifyMember(id,params){
      return this.put(`/api/member/`+id,params)
  }
  //删除用户
  deleteMember(id){
      return this.delete(`/api/member/`+id)
  }

  //获取角色列表
  getRoleList(){
      return this.get(`/api/member/role`)
  }
  //查询角色
  getRoleItem(id){
      return this.get(`/api/member/role/`+id)
  }
  //角色列表模糊查询
  searchRoleList(addcim){
      return this.get(`/api/member/role?`+addcim)
  }
  //新增角色
  addRole(params){
      return this.post(`/api/member/role`,params)
  }
  //修改角色
  modifyRole(id,params){
      return this.put(`/api/member/role/`+id,params)
  }
  //删除角色
  deleteRole(id){
      return this.delete(`/api/member/role/`+id)
  }
  //重置密码
  resetPwd(id){
    return this.put(`/api/member/${id}/password/reset`)
  }
}

export default new Role()



// WEBPACK FOOTER //
// ./src/api/RoleModule.js